import React from 'react';

import { SizeType } from 'app/developer-v3/teams/team-technical-support-operations/get-help';

//TODO: see about removing DocLinks and List, etc, in lieu of
// PartnerAdditionalHelp being a public component in get-help-package
import List from './List';
import DocLink from './DocLink';

type Link = {
  href: string;
  title: string;
};

type DocLinksProps = {
  /** Docs to link */
  links: Link[];
  /** Size to display. */
  size?: SizeType;
};

/** Renders a list of docs. */
const DocLinks = ({ links, size = 'large' }: DocLinksProps) => (
  <List
    gap={5}
    itemRenderer={(item: Link) => <DocLink {...item} size={size} />}
    items={links}
  />
);

export default DocLinks;
